export const INTERNET_CHANGED = "env::internet::change";
